import React from 'react';
import { ApprovalActionTypes, ApprovalStatusEnum, BookingApprovalStatusEnum } from '../../../constants/Enums';
import { ReactComponent as IconReject } from '../../../svg/Icon_Reject.svg';
import { ReactComponent as IconApprove } from '../../../svg/Icon_Approve.svg';
import { useModal } from '@adserve/adserve-react-components';
import ApprovalModal from './ApprovalModal';
import { ActionWorkflow, GetWorkflowRequest } from '../../../services/WorkflowService';

const sortIcon = {
    height: 25,
    width: 25,
};

const ApprovalStatus = ({ data, refreshCampaign, activeBookingRequest, canApprove = false }) => {
    const { addMessage, removeMessage } = useModal();

    const handleActionRequest = async (approve, note) => {
        const request = await GetWorkflowRequest(data.workflowRequestId);


        if (approve) {
            const approveAction = request.activeActions.find(x => x.action.actionType === ApprovalActionTypes.APPROVE);
            if (approveAction) {
                ActionWorkflow(approveAction.requestId, approveAction.transitionId, approveAction.actionId).then(() => {

                    if (note) {
                        // This is so the notes viewer can understand and display the note
                        const slateObject = [{
                            type: 'paragraph',
                            children: [{ text: note }]
                        }];

                        const noteObj = {
                            name: 'Booking request approval',
                            description: '',
                            entityId: data.campaignId,
                            slateValue: JSON.stringify(slateObject)
                        };

                        const NoteService = require('../../../services/NoteService');
                        NoteService.createNote(noteObj, 'campaign').then(() => {
                            if (refreshCampaign) {
                                refreshCampaign();
                            }
                            removeMessage();
                        });
                    } else {
                        if (refreshCampaign) {
                            refreshCampaign();
                        }
                        removeMessage();
                    }
                });
            }
        } else {
            const denyAction = request.activeActions.find(x => x.action.actionType === ApprovalActionTypes.DENY);
            if (denyAction) {
                ActionWorkflow(denyAction.requestId, denyAction.transitionId, denyAction.actionId).then(() => {
                    if (refreshCampaign) {
                        refreshCampaign();
                    }
                    removeMessage();
                });
            }
        }
    };

    const handleRejectClick = () => {
        addMessage({
            message: <ApprovalModal isApproving={false} onActionRequest={handleActionRequest} />
        });
    };

    const handleApproveClick = () => {
        addMessage({
            message: <ApprovalModal isApproving={true} onActionRequest={handleActionRequest} />
        });
    };

    return data.approvalStatus === BookingApprovalStatusEnum.REJECTED ? (
        window.translate(ApprovalStatusEnum.REJECTED)
    ) : data.approvalStatus === BookingApprovalStatusEnum.APPROVED ? (
        window.translate(ApprovalStatusEnum.APPROVED)
    ) : data.approvalStatus === BookingApprovalStatusEnum.AWAITING_APPROVAL ? (
        canApprove && data.canApproveWorkflow ? (
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <IconReject
                    style={sortIcon}
                    fill='red'
                    cursor='pointer'
                    onClick={handleRejectClick}
                />
                <IconApprove
                    style={sortIcon}
                    fill='green'
                    cursor='pointer'
                    onClick={handleApproveClick}
                />
            </div>
        ) : (window.translate(ApprovalStatusEnum.AWAITING_APPROVAL))
    ) : window.translate(ApprovalStatusEnum.NOT_REQUESTED);
};

export default ApprovalStatus;
